import React, { useEffect } from "react";
import AtendimentoProvider from "./AtendimentoContext";
import Atendimento from "./Events/Atendimento";
import { LoadMask } from "../../../../Utils/mask";

const Index = () => {
  useEffect(() => {
    LoadMask();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <AtendimentoProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">{<Atendimento />}</div>
    </AtendimentoProvider>
  );
};

export default Index;
